import { render, staticRenderFns } from "./wechatzhanghu.vue?vue&type=template&id=1efdd818&scoped=true"
import script from "./wechatzhanghu.vue?vue&type=script&lang=js"
export * from "./wechatzhanghu.vue?vue&type=script&lang=js"
import style0 from "./wechatzhanghu.vue?vue&type=style&index=0&id=1efdd818&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../../../../../../opt/build-cache/yunying/node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1efdd818",
  null
  
)

export default component.exports